// extracted by mini-css-extract-plugin
export default {"wrapper":"Popper_wrapper__NIDsY","custom-tooltip":"Popper_custom-tooltip__xLHCN"};